module.exports = __webpack_public_path__ + "static/media/rest-api.5737411e.png";